@for (item of discounts; track item) {
  <div class="year_sale_row" id="year_sale_row">
    <div class=" sale_row">
      <label class="pure-material-checkbox">
        <input type="checkbox" [disabled]="disableEnableCheckbox(item)" [(ngModel)]="item.Selected"
          (change)="onDiscCheck($event,item.DiscountId)">
          <span></span>
        </label>
        <div class="prolabel">
          <a class="yearlink" [class.collapsed]="expandedDiscountId !== item.DiscountId" role="button" tabindex="0"
            [attr.aria-expanded]="expandedDiscountId === item.DiscountId" (click)="toggleDiscount(item.DiscountId)"
            (keydown.enter)="toggleDiscount(item.DiscountId)" (keydown.space)="$event.preventDefault(); toggleDiscount(item.DiscountId)">
            <i class="fa fa-caret-right"></i>{{item.DiscountName}}
          </a>
        </div>
      </div>
      <div class="collapse yearsale" [class.show]="expandedDiscountId === item.DiscountId">
        <div class="col-10">
          <div class="row">
            <div class="col-6">
              <label i18n="@@Period_Start">Effective Date</label>
              <div class="">
                <ejs-datepicker class="form-control p-0 h-auto" required name="date" format='MM/dd/yyyy' floatLabelType='Always'
                  (renderDayCell)="onLoadEffectiveDate($event)" [(ngModel)]="item.PeriodStartDateTime"
                  [disabled]="item.CategoryId == EnumDiscount.PrePayment" [allowEdit]="false"
                  (change)="onEffectiveDateChange($event,item.DiscountId)">
                </ejs-datepicker>
              </div>
            </div>
            <div class="col-6">
              <label i18n="@@Period_Start">Stop Date</label>
              <div class="">
                <ejs-datepicker class="form-control p-0 h-auto" required name="date" [readonly]="!item.Selected"
                  [(ngModel)]="item.StopDate" [format]="moduleType == EModuleType.MakePayment ? MM/dd/yyyy : ''"
                  floatLabelType='Always' [disabled]="item.UnitReccurringDiscountId == 0"
                  (renderDayCell)="onLoadStopDate($event, item.PeriodStartDateTime, item.NumberOfPeriods)"
                  (change)="onStopDateChange($event,item.DiscountId)">
                </ejs-datepicker>
              </div>
            </div>
          </div>
        </div>
        <div class="col-10 mt-2">
          <div class="row">
            <div class="col-6">
              <label i18n="@@Discount">Discount</label>
              <input type="number" class="form-control inputresp" value="" [min]="0" [max]="item.MaxDiscValueAllowed"
                [disabled]="!item.AllowToOverrideDisValue" [(ngModel)]="item.DiscountValue"
                (input)="onInputChange($event, item)" />
              </div>
              <div class="col-6">
                <label i18n="@@Number_of_Periods">Number of Periods</label>
                <input type="number" class="form-control inputresp" value="" min="0" [max]="item.MaxDiscPeriodAllowed"
                  [disabled]="!item.AllowToOverrideDisPeriod" [(ngModel)]="item.NumberOfPeriods"
                  (ngModelChange)="onValueChanges($event, item, 'Periods')"
                  (keyup)="item.NumberOfPeriods=maxValueValidate($event.target.value,item.MaxDiscPeriodAllowed)" />
                </div>
              </div>
            </div>
            <div class="col-10 mt-2">
              <label i18n="@@Modification_Reason">Modification Reason</label>
              <textarea class="form-control" rows="2" [(ngModel)]="item.Notes"
              [disabled]="moduleType == EModuleType.ModifyRental ? item.CategoryId == EnumDiscount.PrePayment : false"></textarea>
            </div>
          </div>
        </div>
      }